export const MAX_CLIENT_RESTRICTION_REFRESH_DELAY_MS = 2_147_483_647;

type ScheduleClientRestrictionRefreshParams = {
  hasExpiredRestrictions: boolean;
  nextLiftAtMs: number | null;
  onRestrictionRefreshDue?: () => void;
};

export const scheduleClientRestrictionRefresh = ({
  hasExpiredRestrictions,
  nextLiftAtMs,
  onRestrictionRefreshDue,
}: ScheduleClientRestrictionRefreshParams) => {
  if (!onRestrictionRefreshDue) {
    return () => {};
  }

  if (hasExpiredRestrictions) {
    onRestrictionRefreshDue();
    return () => {};
  }

  if (nextLiftAtMs === null) {
    return () => {};
  }

  let timeout: ReturnType<typeof setTimeout> | null = null;
  let isCancelled = false;

  const scheduleNextTimeout = () => {
    if (isCancelled) {
      return;
    }

    const delayMs = nextLiftAtMs - Date.now();

    if (delayMs <= 0) {
      onRestrictionRefreshDue();
      return;
    }

    timeout = setTimeout(
      scheduleNextTimeout,
      Math.min(delayMs, MAX_CLIENT_RESTRICTION_REFRESH_DELAY_MS)
    );
  };

  scheduleNextTimeout();

  return () => {
    isCancelled = true;

    if (timeout) {
      clearTimeout(timeout);
    }
  };
};
